import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import { mediaQuery } from '@lacedltd/laced-components'

export const AdjustButton = styled.button({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  background: 'none',
  border: 'none',
  padding: tokens.spacing[1],
  color: tokens.color.airJordan[400],
  transition: 'color 0.15s ease',

  svg: {
    width: '0.85rem',
    height: '0.85rem',
    flexShrink: 0
  },

  '&:hover': {
    color: tokens.color.airJordan.p
  }
})

export const SliderPanel = styled.div({
  overflow: 'hidden',
  transition: 'max-height 0.3s ease, opacity 0.2s ease, padding 0.3s ease',
  borderTop: `${tokens.borderWidth.xs} solid ${tokens.color.airJordan[200]}`,
  marginTop: tokens.spacing[5],
  padding: `${tokens.spacing[6]} 0 ${tokens.spacing[2]}`,

  [mediaQuery.m.max]: {
    display: 'none'
  }
})

export const SliderLoading = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: `${tokens.spacing[6]} 0`,
  fontSize: tokens.fontSize[1],
  color: tokens.color.airJordan[500]
})

export const ButtonRow = styled.div({
  display: 'flex',
  gap: tokens.spacing[3],
  marginTop: tokens.spacing[5]
})

export const MatchLastSoldButton = styled.button({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: tokens.spacing[2],
  padding: `${tokens.spacing[3]} ${tokens.spacing[4]}`,
  fontSize: tokens.fontSize[1],
  fontWeight: 500,
  color: tokens.color.foamRunner[700],
  background: 'none',
  border: `${tokens.borderWidth.xs} solid ${tokens.color.foamRunner[400]}`,
  borderRadius: tokens.borderRadius.m,
  cursor: 'pointer',
  transition: 'background 0.15s ease, border-color 0.15s ease',
  whiteSpace: 'nowrap' as const,

  '&:hover': {
    background: tokens.color.foamRunner[50],
    borderColor: tokens.color.foamRunner[600]
  }
})

export const SaveButton = styled.button<{
  variant?: 'default' | 'saving' | 'error'
}>(({ variant = 'default' }) => ({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: `${tokens.spacing[3]} ${tokens.spacing[4]}`,
  fontSize: tokens.fontSize[1],
  fontWeight: 600,
  color: tokens.color.yeezy[0],
  background:
    variant === 'error'
      ? tokens.color.roshe[600]
      : variant === 'saving'
      ? tokens.color.foamRunner[400]
      : tokens.color.foamRunner[600],
  border: 'none',
  borderRadius: tokens.borderRadius.m,
  cursor: variant === 'saving' ? 'wait' : 'pointer',
  transition: 'background 0.15s ease, opacity 0.15s ease',
  whiteSpace: 'nowrap' as const,

  '&:hover': {
    background:
      variant === 'error'
        ? tokens.color.roshe[700]
        : variant === 'saving'
        ? tokens.color.foamRunner[400]
        : tokens.color.foamRunner[700]
  },

  '&:disabled': {
    opacity: 0.5,
    cursor: 'not-allowed'
  }
}))

export const QueueRow = styled.p({
  fontSize: tokens.fontSize[1],
  color: tokens.color.foamRunner[700],
  lineHeight: 1.5,
  margin: `0 0 ${tokens.spacing[3]}`,
  padding: `${tokens.spacing[2]} ${tokens.spacing[3]}`,
  background: tokens.color.foamRunner[50],
  borderRadius: tokens.borderRadius.s,

  b: {
    fontWeight: 600
  }
})

export const PriceInputRow = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: tokens.spacing[3],
  marginTop: tokens.spacing[4]
})

export const PriceInputLabel = styled.span({
  fontSize: tokens.fontSize[1],
  color: tokens.color.airJordan[400],
  whiteSpace: 'nowrap' as const
})

export const PriceInput = styled.input({
  flex: 1,
  maxWidth: '120px',
  padding: `${tokens.spacing[2]} ${tokens.spacing[3]}`,
  fontSize: tokens.fontSize[2],
  fontWeight: 500,
  color: tokens.color.airJordan.p,
  border: `${tokens.borderWidth.xs} solid ${tokens.color.airJordan[200]}`,
  borderRadius: tokens.borderRadius.s,
  background: 'transparent',
  outline: 'none',
  transition: 'border-color 0.15s ease',
  textAlign: 'right' as const,

  '&:focus': {
    borderColor: tokens.color.airJordan[400]
  },

  '&::placeholder': {
    color: tokens.color.airJordan[300]
  }
})

export const PayoutRow = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: tokens.spacing[3],
  padding: `${tokens.spacing[2]} 0`,
  borderTop: `${tokens.borderWidth.xs} solid ${tokens.color.airJordan[100]}`
})

export const PayoutLabel = styled.span({
  fontSize: tokens.fontSize[1],
  color: tokens.color.airJordan[400]
})

export const PayoutValue = styled.span({
  fontSize: tokens.fontSize[2],
  fontWeight: 500,
  color: tokens.color.airForce[700]
})
